"use strict";

exports.__esModule = true;
exports.default = composeEventHandlers;

function composeEventHandlers() {
  for (var _len = arguments.length, handlers = new Array(_len), _key = 0; _key < _len; _key++) {
    handlers[_key] = arguments[_key];
  }

  var fns = handlers.filter(function (fn) {
    return Boolean(fn);
  });

  if (fns.length === 0) {
    return undefined;
  } else if (fns.length === 1) {
    return fns[0];
  } else {
    return function (event) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      var prevented = false;
      return fns.forEach(function (fn) {
        if (!prevented) {
          fn.apply(void 0, [event].concat(args));
          prevented = event.nativeEvent.preventMineralDefault;
        }
      });
    };
  }
}